/* eslint-disable @nx/enforce-module-boundaries */
import { NavigationContainerWrapper } from '@marriott/mi-common-static-components';
import { usePageContext } from '@marriott/mi-shop-components';
import { FEATURE_FLAGS } from '@marriott/mi-feature-flag-utils';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const ONavigationContainer = (props: any) => {
  const { isAuthorMode = false } = usePageContext();

  return (
    <NavigationContainerWrapper
      {...props}
      isAuthorMode={isAuthorMode}
      featureFlagLegacyNav={{ [FEATURE_FLAGS.EXPERIENCE_MCOM_LEGACY_NAV]: true }}
    />
  );
};
